import { isMobile } from "@common_lib/base/utils/src/tools"

const setFontSizeConfig = () => {
  if (isMobile()) {
    const vw = document.documentElement.clientWidth
    const scale = vw / 375
    const rootElement = document.querySelector(":root")

    if (rootElement) {
      ;(rootElement as HTMLElement).style.setProperty("--font-size-base", `${scale * 16}`)
    }
  }
}

export default setFontSizeConfig
